import {
  Required,
  DataValidator,
  transformKeys,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface KnowledgeUpdateFolderItemDetailResponse {
  detail: Detail;
};

export interface Detail {
  id: number;
  content_title: string;
};

class DetailData {
  @IsNumber("Id must be a number")
  id: number;

  @IsString("Content title must be a string")
  content_title: string;
}

class KnowledgeUpdateFolderItemDetailData {
  @ValidateNested(DetailData)
  detail: DetailData;
}

const transformAndValidateData = (
  response: KnowledgeUpdateFolderItemDetailResponse
): KnowledgeUpdateFolderItemDetailData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeUpdateFolderItemDetailData);
  } catch (error) {
    console.error("Knowledge folder rename data validation failed:", error.message);
    throw error;
  }
};

/** 更新知识库卡片 */
export const knowledgeUpdateFolderItemDetail = async ({
  itemDetailId,
  contentTitle,
  itemContent,
}: {
  itemDetailId: number,
  contentTitle: string
  itemContent?: string,
}) => {
  const res = await api.post<KnowledgeUpdateFolderItemDetailResponse>('/knowledge/update_folder_item_detail', {
    item_detail_id: itemDetailId,
    content_title: contentTitle,
    item_content: itemContent,
  });
  const data = transformAndValidateData(res.data);
  return data;
}